import React, { useContext } from "react";
import pptpage from "../Driveanalysis/pptpage.pdf";
// import drive_erc from "../Driveanalysis/Drive_Erc.pdf";
import drive_erc from "../Driveanalysis/DriveErc.pdf";
import DashboardMain from "../DashboardMain/DashboardMain";
import AppContext from "../../../store/AppContext";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PPTPage() {
  const app_ctx = useContext(AppContext);

  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <DashboardMain>
        {loggedInUser.flagForHideShow !== "ERC" ? (
          <iframe
            src={pptpage}
            style={{ marginTop: "7%" }}
            frameborder="0"
            height="500em"
            width="100%"
            sandbox
          ></iframe>
        ) : (
          <iframe
            src={drive_erc}
            style={{ marginTop: "7%" }}
            frameborder="0"
            height="500em"
            width="100%"
            sandbox
          ></iframe>
        )}
      </DashboardMain>
    </>
  );
}

export default PPTPage;
